import { withInstall } from '@jdesign-vue/utils'
import CascaderPanel from './src/index.vue'

export const JdCascaderPanel = withInstall(CascaderPanel)
export default JdCascaderPanel

export * from './src/types'
export * from './src/config'
export * from './src/instance'
